import * as React from "react";
const SvgPenSquare = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M9.16665 3.33357H7.33331C5.93318 3.33357 5.23312 3.33357 4.69834 3.60605C4.22793 3.84574 3.84548 4.22819 3.6058 4.69859C3.33331 5.23337 3.33331 5.93344 3.33331 7.33357V12.6669C3.33331 14.067 3.33331 14.7671 3.6058 15.3019C3.84548 15.7723 4.22793 16.1547 4.69834 16.3944C5.23312 16.6669 5.93318 16.6669 7.33331 16.6669H12.6666C14.0668 16.6669 14.7668 16.6669 15.3016 16.3944C15.772 16.1547 16.1545 15.7723 16.3942 15.3019C16.6666 14.7671 16.6666 14.067 16.6666 12.6669V10.4169M7.49998 12.5002L8.96225 12.2113C9.55346 12.0944 9.84907 12.036 10.1247 11.9284C10.3694 11.8329 10.6019 11.7088 10.8175 11.5587C11.0603 11.3896 11.2734 11.1765 11.6995 10.7504L16.7319 5.71798C17.3828 5.06711 17.3828 4.01183 16.7319 3.36096C16.081 2.71008 15.0257 2.71008 14.3749 3.36096L9.26915 8.46666C8.86984 8.86597 8.67019 9.06562 8.50894 9.29194C8.3658 9.49286 8.24539 9.70905 8.14995 9.93654C8.04244 10.1928 7.97782 10.4676 7.84859 11.0174L7.49998 12.5002ZM15.5696 6.91277L16.7482 5.73426C17.399 5.08338 17.399 4.02811 16.7482 3.37723C16.0973 2.72636 15.042 2.72636 14.3911 3.37723L13.2126 4.55575L15.5696 6.91277Z",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgPenSquare;
